import { logoDomain } from '@trello/config';

export const logosFromLogoHash = (logoHash: string) => {
  return ['30', '50', '170'].reduce(
    (logos: { [key: string]: string }, size) => {
      logos[size] = `${logoDomain}/${logoHash}/${size}.png`;
      return logos;
    },
    {},
  );
};
